/**
 * Created by danil on 06.06.14.
 */

Ext.ns('mx.app.widget');

mx.app.widget.Limitation = Ext.extend(mx.comp.FieldGroup, {
    namespace: 'mx',

    periodDefaultValue: 0,
    periodStrategy: {
        xtype: 'number',
        minValue: 0,
        maxValue: 59,
        allowDecimals: false,
    },

    counterDefaultValue: 0,
    counterStrategy: {
        xtype: 'number',
        minValue: -1,
        maxValue: 999,
        allowDecimals: false,
    },

    label: 'in',

    initComponent: function() {
        this.columns = [60, 30, 1];

        var periods = [['s', mx.translate('seconds', this.namespace)], ['m', mx.translate('minutes', this.namespace)]];

        this.items = [
            (this.counter = new Ext.ux.form.Spinner({
                strategy: this.counterStrategy,
                value: this.counterDefaultValue,
            })),

            new Ext.form.Label({
                xtype: 'label',
                text: mx.translate(this.label, this.namespace),
                style: 'text-align: center; width: 100%;',
            }),

            (this.period = new mx.comp.PeriodField({
                spinnerDefaultValue: this.periodDefaultValue,
                comboDefaultValue: 's',
                comboData: periods,
                spinnerStrategy: this.periodStrategy,
                spinnerWidth: 60,
            })),
        ];
        mx.app.widget.Limitation.superclass.initComponent.call(this);
    },

    getValue: function() {
        var number = parseInt(this.counter.getValue());
        if (number < 0) {
            return -1;
        }
        return this.period.getValue() * 1000 + number;
    },

    setValue: function(v) {
        if (v) {
            if (v < 0) {
                this.counter.setValue(-1);
                this.period.setValue(0);
                return;
            }
            this.counter.setValue(v % 1000);
            this.period.setValue(Math.floor(v / 1000));
        }
    },
});
